import PropTypes from "prop-types";
import React from "react";

/* -------------------------------------------------------------------------
 * CustomerSpendBreakdownCard — Returning vs New customer spend split,
 * with a single two-tone progress bar.
 * ---------------------------------------------------------------------- */

const CustomerSpendBreakdownCard = ({ title, description, returning, newCustomers }) => (
  <div className="rp-card">
    <div className="rp-card__header">
      <div>
        <h2 className="rp-card__title">{title}</h2>
        <p className="rp-card__subtitle">{description}</p>
      </div>
    </div>

    <div className="rp-breakdown__row">
      <span className="rp-breakdown__row-label">Returning Customers</span>
      <span className="rp-breakdown__row-value rp-breakdown__row-value--blue">
        {returning.percent}% (${returning.amount.toLocaleString()})
      </span>
    </div>
    <div className="rp-breakdown__row">
      <span className="rp-breakdown__row-label">New Customers</span>
      <span className="rp-breakdown__row-value">
        {newCustomers.percent}% (${newCustomers.amount.toLocaleString()})
      </span>
    </div>

    <div className="rp-breakdown__track">
      <div className="rp-breakdown__fill" style={{ width: `${returning.percent}%` }} />
    </div>
  </div>
);

CustomerSpendBreakdownCard.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string.isRequired,
  returning: PropTypes.shape({
    percent: PropTypes.number.isRequired,
    amount: PropTypes.number.isRequired,
  }).isRequired,
  newCustomers: PropTypes.shape({
    percent: PropTypes.number.isRequired,
    amount: PropTypes.number.isRequired,
  }).isRequired,
};

CustomerSpendBreakdownCard.defaultProps = {
  title: "Customer Spend Breakdown",
};

export default CustomerSpendBreakdownCard;
